import { render } from "./livromatricula.vue?vue&type=template&id=2e8119f2"
import script from "./livromatricula.vue?vue&type=script&lang=js"
export * from "./livromatricula.vue?vue&type=script&lang=js"

import "./livromatricula.vue?vue&type=style&index=0&id=2e8119f2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__